import React from 'react';
import { Tag, Tooltip } from 'antd';

export default function ParameterComponentTag({ toolId, toolName }: { toolId?: number | null; toolName?: string | null }) {
  if (toolId == null) return null;
  const name = toolName?.trim() || 'Bileşen adı belirtilmemiş';
  return <Tooltip title={name} trigger={['hover', 'focus']}>
    <Tag color='blue' tabIndex={0} aria-label={`Bileşenli: ${name}`} style={{ marginInlineStart: 8, fontWeight: 400 }}>Bileşenli</Tag>
  </Tooltip>;
}
